import { AfterContentInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[autofocusDirective]'
})
export class AutofocusDirective implements AfterContentInit {
  constructor(private elementRef: ElementRef) {}

  public ngAfterContentInit() {
    setTimeout(() => {
      this.elementRef.nativeElement.focus();
    }, 100);
  }
}
